var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8L12.75 8ZM11.25 16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16H11.25ZM16 12.75C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25V12.75ZM8 11.25C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75V11.25ZM19.25 12C19.25 16.0041 16.0041 19.25 12 19.25V20.75C16.8325 20.75 20.75 16.8325 20.75 12H19.25ZM12 19.25C7.99594 19.25 4.75 16.0041 4.75 12H3.25C3.25 16.8325 7.16751 20.75 12 20.75V19.25ZM4.75 12C4.75 7.99594 7.99594 4.75 12 4.75V3.25C7.16751 3.25 3.25 7.16751 3.25 12H4.75ZM12 4.75C16.0041 4.75 19.25 7.99594 19.25 12H20.75C20.75 7.16751 16.8325 3.25 12 3.25V4.75ZM11.25 8L11.25 12H12.75L12.75 8L11.25 8ZM11.25 12V16H12.75V12H11.25ZM16 11.25H12V12.75H16V11.25ZM12 11.25H8V12.75H12V11.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon-add.2fc7d50044e353681cbb40ecb67ff90d.svg";
export { ForwardRef as ReactComponent };